/* eslint-disable no-use-before-define */
import { Box, Chip, TextField } from "@material-ui/core";
import React, { useEffect, useState } from "react";
import Checkbox from "@material-ui/core/Checkbox";
import Autocomplete from "@material-ui/lab/Autocomplete";
import CheckBoxOutlineBlankIcon from "@material-ui/icons/CheckBoxOutlineBlank";
import CheckBoxIcon from "@material-ui/icons/CheckBox";
import { useStyles } from "./style";
import { useDispatch, useSelector } from "react-redux";
import CustomMuiPaper from "../../../../shared/layout/custom-mui-paper";
import { setUserPortfolio, setUserPortfolioCompanies, setUserPortfolioId } from "../../../../stores/user/user-action";
import { getUserPortfolioTeamCodes, saveUserPortfolioDetails } from "../../../../services/bff-service";
import CustomMuiPopper from "../../../../shared/layout/custom-mui-popper";
import { setSnackBar } from "../../../../stores/ui/ui-action";
import { useTeamCodes } from "../../../../stores/company/company.hooks";
import * as filters from "../../../components/company-list/list-filters";
import { useLocation } from "react-router-dom";
import CONSTANTS from "../../../../utils/constants";

type TeamCodeFilterProps = {
  handleTeamCodeToggle: (boolean) => void;
  inputStyle?: string;
};

const {
  FDM_DASHBOARD: {
    TAB_CONFIGS: {
      PORTFOLIO: { value },
    },
  },
} = CONSTANTS;

export function TeamCodeFilter({ handleTeamCodeToggle, inputStyle }: TeamCodeFilterProps) {
  const classes = useStyles();
  const teamCodeOptions = useTeamCodes();
  const { userTeamCodes = [], userCompanies = [] } = useSelector((state: any) => state.user);
  const { companyList } = useSelector((state: any) => state.company);

  const { search } = useLocation();
  const activeTab = new URLSearchParams(search).get("tab") ?? value;

  const { isMyPortfolio } = filters.getActiveTab(activeTab);

  const dispatch = useDispatch();
  const [selectedOptions, setSelectedOptions] = useState([]);
  const [userPortfolioId, setPortfolioId] = useState(null);

  const handleChange = (event, value = []) => {
    if (!value.length) {
      handleTeamCodeToggle(false);
    }
    setSelectedOptions(value);
    saveUserPortfolioTeamCodes(value);
  };

  async function saveUserPortfolioTeamCodes(value) {
    try {
      const { data } = await saveUserPortfolioDetails({
        portfolio_id: userPortfolioId,
        portfolio: {
          teamCodes: value,
          companies: userCompanies,
        },
      });
      const { portfolio_id } = data;
      if (!portfolio_id && !userPortfolioId) {
        throw new Error("Portfolio_id is Missing");
      }
      if (!userPortfolioId) {
        setUserPortfolioId(portfolio_id);
      }
      dispatch(setUserPortfolio(value));
    } catch (error) {
      dispatch(
        setSnackBar({
          show: true,
          message: error.message,
          messageType: "error",
        }),
      );
      console.error(error);
    }
  }

  async function fetchUserPortfolioTeamCodes() {
    try {
      const { portfolio: { teamCodes = [], companies = [] } = {}, portfolio_id = null } =
        await getUserPortfolioTeamCodes();
      setPortfolioId(portfolio_id);
      setSelectedOptions(teamCodes);
      dispatch(setUserPortfolioId(portfolio_id));
      dispatch(setUserPortfolio(teamCodes));
      dispatch(setUserPortfolioCompanies(companies));
    } catch (error) {
      console.error(error);
    }
  }

  const handleDropDownClose = () => {
    if (selectedOptions.length) handleTeamCodeToggle(true);
  };

  useEffect(() => {
    !userPortfolioId && fetchUserPortfolioTeamCodes();
  }, [companyList]);

  return (
    <>
      <Box className={`${classes.menuOptionParent} ${inputStyle}`} display={!isMyPortfolio && "none"}>
        <Autocomplete
          multiple
          id="checkboxes-tags-demo"
          data-testid="teamcode-input-field"
          options={filters.sortTeamCodes(selectedOptions, teamCodeOptions)}
          disableCloseOnSelect
          disablePortal
          PaperComponent={CustomMuiPaper}
          PopperComponent={(props) => <CustomMuiPopper {...props} />}
          value={selectedOptions}
          onChange={handleChange}
          onClose={() => handleDropDownClose()} // Set dropdown open state to false
          renderTags={(value, getTagProps) => (
            <div className={classes.chipBox}>
              {value.map((option, index) => (
                <Chip label={option} {...getTagProps({ index })} className="chip" />
              ))}
            </div>
          )}
          renderOption={(option, { selected }) => (
            <div className={classes.menuOption}>
              <Checkbox
                icon={<CheckBoxOutlineBlankIcon fontSize="small" />}
                className={classes.checkBoxIcon}
                style={{ marginRight: 9 }}
                checkedIcon={<CheckBoxIcon fontSize="small" />}
                checked={selected}
              />
              {option}
            </div>
          )}
          className={classes.customAutocomplete}
          style={{ width: "328px" }}
          renderInput={(params) => (
            <div>
              <TextField
                {...params}
                variant="outlined"
                label={"My Team Codes"}
                inputProps={{
                  ...params.inputProps,
                  readOnly: true,
                }}
                InputProps={{
                  ...params.InputProps,
                  startAdornment: <>{userTeamCodes.length ? params.InputProps.startAdornment : "None"}</>,
                }}
              />
            </div>
          )}
        />
      </Box>
    </>
  );
}
